import { Link, useSearchParams } from "react-router-dom";
import { cn } from "@/lib/utils";

const TabBar = ({ tabs, active, onSelect }) => (
  <nav role="tablist" className="-mb-px flex gap-1 overflow-x-auto">
    {tabs.map((t) => (
      <button
        key={t.key}
        role="tab"
        aria-selected={active === t.key}
        data-testid={`review-tab-${t.key}`}
        onClick={() => onSelect(t.key)}
        className={cn(
          "h-11 whitespace-nowrap border-b px-4 text-[13px]",
          active === t.key ? "border-os-ink font-medium text-os-ink" : "border-transparent text-os-ink-3 hover:text-os-ink",
        )}
      >
        {t.label}
      </button>
    ))}
  </nav>
);

// Generic design-review page: any screen passes its own tabs ({ key, label, note, Panel, scenario }).
export const ReviewShell = ({ title, tabs, barePath }) => {
  const [params, setParams] = useSearchParams();
  const tab = tabs.find((t) => t.key === params.get("tab")) || tabs[0];
  const { Panel } = tab;
  return (
    <div data-testid="review-page">
      <header className="border-b border-os-border bg-white">
        <div className="flex items-end justify-between gap-6 px-6 pt-5 lg:px-12">
          <div className="pb-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.08em] text-os-ink-4">Design review · prototype</p>
            <h1 data-testid="review-title" className="mt-1 text-[16px] font-semibold tracking-[-0.01em]">{title}</h1>
          </div>
          <Link
            to={`${barePath}?scenario=${tab.scenario}`}
            target="_blank"
            data-testid="open-bare-board-link"
            className="mb-4 inline-flex h-9 items-center rounded-control border border-os-border bg-white px-4 font-mono text-[12px] text-os-ink hover:border-os-border-strong"
          >
            Open bare board
          </Link>
        </div>
        <div className="px-6 lg:px-12">
          <TabBar tabs={tabs} active={tab.key} onSelect={(key) => setParams({ tab: key })} />
        </div>
      </header>
      <section data-testid={`review-panel-${tab.key}`} className="px-6 py-8 lg:px-12">
        <p className="mb-6 max-w-3xl text-[13px] text-os-ink-2">{tab.note}</p>
        <Panel key={tab.key} />
      </section>
    </div>
  );
};
